// extracted by mini-css-extract-plugin
module.exports = {"box":"CircleBaseBox_box_2tiuE","top-bar":"CircleBaseBox_top-bar_3In05","right":"CircleBaseBox_right_2GrIB","border-top":"CircleBaseBox_border-top_2J3c0"};